import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDepartmentFilterList = createAsyncThunk("fetchDepartmentFilterList", async ({ page, filters, limit }) => {
	const keyword = filters && filters.keyword !== undefined ? `${filters.keyword}` : "";
	const company = filters && filters.company !== undefined ? `${filters.company}` : "";
	const vc = filters && filters.valueChain !== undefined ? `${filters.valueChain}` : "";
	const department = filters && filters.parentDepartment !== undefined ? `${filters.parentDepartment}` : "";

	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(
		`department/list?page=${page}&limit=100000000000&keyword=${keyword}${company ? "&company=" + company : ""}&department=${department}&valuechain=${vc}`,
		config
	);

	return response.data.data;
});

const departmentFliterListSlice = createSlice({
	name: "departmentFliterList",
	initialState: {
		isLoading: false,
		filterdata: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchDepartmentFilterList.pending, (state, action) => {
			state.isLoading = true;
			state.filterdata = [];
		});

		builder.addCase(fetchDepartmentFilterList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.filterdata = action.payload;
			state.page = action.payload.page;
			state.total = action.payload.total;
		});
		builder.addCase(fetchDepartmentFilterList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default departmentFliterListSlice.reducer;
